<template>
  <div>
    <filter-data
      with_client_portfolios
      :loading_block="loading"
      with_company
      with_bank
      with_company_banks
      :months_after="0"
      with_text_search
      with-deposit-situation-select
      :deposit-situation-items="deposit_type"
      :deposit-situation-value="deposit_filter.status_ids"
      @doneFilter="handleDoneFilter"
    />
    <deposits-table
      :items="allDeposits"
      :loading="loading"
      :table-search="tableSearch"
      @doneUpdate="handleDoneUpdate"
      @doneDelete="handleDoneDelete"
      @doneReturned="handleDoneReturned"
    />
  </div>
</template>

<script>
const PAYED_ID = 7
const CONCLUDED_ID = 16
const RETURNED_FILTER_FLAG = -1

import { mapActions, mapState, mapGetters } from 'vuex'
import status from '../../mixins/status';
import FilterData from '@/components/shared/FilterData.vue'

export default {
  name: 'OpenDeposits',
  mixins: [ status ],
  inject: {
    registerDepositsListReload: {
      default: () => () => {},
    },
  },
  components: {
    DepositsTable: () => import('./shared/DepositsTable'),
    FilterData,
  },
  data() {
    return {
      loading: false,
      local_filter: {},
      deposit_filter: {
        status_ids: [PAYED_ID],
      },
      deposit_type:[
        {text:"PAGOS", value: PAYED_ID },
        {text:"CONCLUÍDOS", value: CONCLUDED_ID },
        {text:"RETORNADOS", value: RETURNED_FILTER_FLAG },
      ],
    }
  },
  methods: {
    handleDoneFilter(e) {
      const { status_ids, ...rest } = e
      if (status_ids !== undefined) {
        this.deposit_filter = { status_ids: [...status_ids] }
      }
      this.local_filter = { ...rest }
      this.getDeposits()
    },
    handleDoneUpdate(){
      this.getDeposits()
    },
    handleDoneReturned(){
      this.getDeposits()
    },
    handleDoneDelete(){
      this.getDeposits()
    },
    getDeposits() {
      this.loading = true
      let filters = {
        modality_ids: [this.activeModalityId],
        ...this.deposit_filter,
        ...this.local_filter
      }
      this.$emit('doneFilter', {...filters} )
      if (this.activeModalityId){
        this.indexDeposits(filters).finally(()=>{
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    ...mapActions({
      indexDeposits: 'Deposit/index',
    })
  },
  
  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allDeposits: state => state.Deposit.allDeposits,
    }),
  },
  mounted() {
    this.registerDepositsListReload(this.getDeposits)
  },
  beforeDestroy() {
    this.registerDepositsListReload(null)
  },
  watch: {
    activeModalityId() {
      this.getDeposits()
    },
  },
}
</script>